export default __webpack_public_path__ + "865a830c23a34f64d14e754e2f42cdad.png";